export var getType = function (obj) { return Object.prototype.toString.call(obj); };
function typeChecker(type) {
    return function (obj) { return getType(obj) === "[object " + type + "]"; };
}
// eslint-disable-next-line @typescript-eslint/ban-types
export var isFn = function (val) { return typeof val === "function"; };
export var isArr = Array.isArray;
// eslint-disable-next-line @typescript-eslint/ban-types
export var isPlainObj = typeChecker("Object");
export var isStr = typeChecker("String");
export var isBool = typeChecker("Boolean");
export var isNum = typeChecker("Number");
// eslint-disable-next-line @typescript-eslint/ban-types
export var isObj = function (val) { return typeof val === "object"; };
export var isPrimitive = function (val) {
    return isStr(val) || isBool(val) || isNum(val);
};
export function instanceOf(inst, cls) {
    if (isFn(cls)) {
        return inst instanceof cls;
    }
    return false;
}
